// @flow
import React from 'react';
import i18n from 'app/common/lib/i18n';
import { Button } from 'gestalt';

type Props = {|
  handleFollowClick: () => void,
  isFollowing: boolean,
  isSelf: boolean,
|};

export default function FollowButton({ handleFollowClick, isFollowing, isSelf }: Props) {
  const text = isFollowing ? i18n._('Unfollow') : i18n._('Follow');

  return isSelf ? (
    <Button
      inline
      disabled
      text={i18n._("That's you!", "Text describing that the person's avatar is you")}
    />
  ) : (
    <Button color={isFollowing ? 'gray' : 'red'} inline onClick={handleFollowClick} text={text} />
  );
}
